import { useConfig } from '@default-config';
import type { Links } from '../config/links';

export const useLinks = (): Links => {
    const { links } = useConfig();

    return links;
};
